import React, { FC } from 'react';
import clsx from 'clsx';

import Loader from 'components/Loader';
import useLayoutTheme from 'hooks/useLayoutTheme';

import styles from './Button.module.scss';

export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Inverted = 'inverted',
  Transparent = 'transparent',
  Danger = 'danger',
  InputButton = 'input button',
  OptionButton = 'option button',
  ChatOptionButton = 'chat option button',
}

interface ButtonProps {
  onClick?: () => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  type?: ButtonType;
  id?: string;
  loaderSize?: number;
  style?: React.CSSProperties;
}

const getButtonStyles = (buttonType: ButtonType) => {
  switch (buttonType) {
    case ButtonType.Primary:
      return styles.primary;

    case ButtonType.Secondary:
      return styles.secondary;

    case ButtonType.Inverted:
      return styles.inverted;

    case ButtonType.Transparent:
      return styles.transparent;

    case ButtonType.InputButton:
      return styles.inputButton;

    case ButtonType.OptionButton:
      return styles.optionButton;

    case ButtonType.Danger:
      return styles.danger;

    case ButtonType.ChatOptionButton:
      return styles.chatOptionButton;

    default:
      return null as never;
  }
};

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  className,
  isLoading,
  disabled,
  type = ButtonType.Primary,
  id,
  loaderSize,
  style,
}) => {
  const { themeStyles, theme, shouldApplyTheme } = useLayoutTheme();
  return (
    <button
      id={id}
      type="button"
      className={clsx(
        styles.button,
        themeStyles.button,
        getButtonStyles(type),
        className,
        isLoading && themeStyles.isLoading,
        shouldApplyTheme && styles[theme],
      )}
      onClick={onClick}
      disabled={disabled || isLoading}
      style={style}
    >
      {isLoading ? <Loader isButtonLoader size={loaderSize} /> : children}
    </button>
  );
};

export default Button;
